<template>
  <div>
    <div class="container fr-aic fr-jcsb">
      <comp-tab :data="[{ label: '全部优惠券模版', value: 2 }, { label: '已删除', value: 1 }]" v-model="params.isdeleted" />
      <el-button @click="$router.push({ name: 'marketing-coupon-template-edit' })" size="small" type="primary">新建优惠券模版</el-button>
    </div>

    <div class="container">
      <el-row gutter="8">
        <el-col span="4">
          <el-input placeholder="ID" prefix-icon="el-icon-search" size="small" v-model="params.id"></el-input>
        </el-col>
        <el-col span="4">
          <el-button @click="onSearch" size="small">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-table :data="list" border row-key="id">
        <el-table-column label="ID" prop="id" width="50px" />
        <el-table-column label="名称" prop="name" />
        <el-table-column label="面值">
          <template slot-scope="scope">
            <div v-if="scope.row.amountkind == 0">{{ `${$amount1(scope.row.amountbegin)}元 ~ ${$amount1(scope.row.amountend)}元` }}</div>
            <div v-else>{{ $amount1(scope.row.amount) }}元</div>
          </template>
        </el-table-column>
        <el-table-column label="使用条件" prop="rule">
          <template slot-scope="scope">
            <div v-if="scope.row.reach === 0">不限制</div>
            <div v-else>满{{ $amount1(scope.row.reach) }}元可用</div>
          </template>
        </el-table-column>
        <el-table-column label="有效期">
          <template slot-scope="scope">
            <div v-if="scope.row.timekind === 0">不限制</div>
            <div v-if="scope.row.timekind === 2">发放或领取后{{ scope.row.duration / 60 / 60 / 24 }}天</div>
          </template>
        </el-table-column>
        <el-table-column label="生效范围">
          <template slot-scope="scope">
            <div v-if="scope.row.producttype === 0">可用于所有商品</div>
            <div v-if="scope.row.producttype === 1">可用于部分商品</div>
            <div v-if="scope.row.producttype === 2">不可用于部分商品</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="$router.push({ name: 'marketing-coupon-template-detail', query: { id: scope.row.id } })" size="small" type="text">明细</el-button>
            <el-button @click="onClickDel(scope.row)" size="small" type="text" v-if="scope.row.deletedat == 0">删除</el-button>
            <el-button @click="onClickCopy(scope.row)" size="small" type="text" v-if="scope.row.deletedat > 0">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-bottom">
        <el-button v-if="hasMore" :loading="loadmore" @click="getCouponTemplates" size="small" type="primary">加载更多</el-button>
        <span style="color: #ccc; font-size: 12px;" v-else>已经加载完成，没有更多了</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../../components/tab/index.vue';
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

export default {
  components: {
    'comp-tab': Tab
  },
  data() {
    return {
      status: 2,
      params: {
        id: '',
        isdeleted: 2,
        idlessthan: 0,
        count: 20
      },
      list: [],
      loadmore: false,
      hasMore: true,
      token: ''
    };
  },
  watch: {
    'params.isdeleted': function() {
      this.list = [];
      this.getCouponTemplates();
    }
  },
  created() {
    this.token = getToken();
    this.getCouponTemplates();
  },
  methods: {
    async getCouponTemplates() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      const res = await rpc(
        'StoreCouponTemplateService.GetCouponTemplateList',
        M('CouponTemplateListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      this.list = this.list.concat(res.coupontemplatelistList);
      this.hasMore = res.coupontemplatelistList.length;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
      this.loadmore = false;
    },

    async onClickCopy(row) {
      row = JSON.parse(JSON.stringify(row));
      row.deletedat = 0;
      const res = await rpc(
        'StoreCouponTemplateService.CreateCouponTemplate',
        M('CouponTemplateWithTokenRequest', {
          token: M('Token', { token: this.token }),
          coupontemplate: M('CouponTemplate', row)
        })
      );
      this.list.splice(0, 0, res);
      this.$message({
        message: '操作成功',
        type: 'success'
      });
    },

    onClickDel(row) {
      row = JSON.parse(JSON.stringify(row));
      row.deletedat = parseInt(Date.now() / 1000);
      rpc(
        'StoreCouponTemplateService.UpdateCouponTemplate',
        M('CouponTemplateWithTokenRequest', {
          token: M('Token', { token: this.token }),
          coupontemplate: M('CouponTemplate', row)
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    },

    onSearch() {
      this.list = [];
      this.getMarketings();
    }
  }
};
</script>

<style></style>
